import React from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from '@devexpress/dx-react-grid';
import InputText from '@/components/UI/InputText/InputText';
import styles from '../SearchTable.module.scss';

interface UsersTableHeaderProps {
  handleFilterChange: (filter: Filter[]) => void; // eslint-disable-line no-unused-vars
  filters: Filter[];
}

const UsersTableHeader: React.FC<UsersTableHeaderProps> = (props) => {
  const { handleFilterChange, filters } = props;
  const { t } = useTranslation();

  const handleChangeValues = (value: string) => {
    const filter = { columnName: 'allFields', value, operation: 'contains' };
    const newFiters = filters.find((f) => f.columnName === 'allFields') ? filters.map((f) => (f.columnName === 'allFields' ? filter : f)) : [...filters, filter];
    handleFilterChange(newFiters);
  };

  const filterValue = filters.find((filter: Filter) => filter.columnName === 'allFields')?.value ?? '';

  return (

    <div className={styles.TableSelectionHeader}>
      <InputText
        id="input-free-text"
        handleChange={(ev) => handleChangeValues(ev.target.value)}
        value={filterValue}
        type="search"
        icoSearch
        maxLength={256}
        label={t('search')}
        size="small"
        className={`${styles.FilterCell} ${filterValue !== '' ? styles.ActiveInputTextFilterCell : ''}`}
      />
      <div className={styles.ButtonResetFilter} onClick={() => handleFilterChange([])}>{t('dialog.resetFilter')}</div>
    </div>
  );
};

export default UsersTableHeader;
